import classNames from "classnames";
import { motion } from "framer-motion";
import React from "react";
import MealImage from "./MealImage";
const mealItemAnim = {
    hidden: { opacity: 0 },
    show: { opacity: 1 },
    exit: { opacity: 0, transition: {
            duration: 0
        } }
};
export default class Meal extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.isValid = () => this.props.meal.variant_id !== null;
    }
    render() {
        const { meal, category, onChange } = this.props;
        const { nutriants } = meal;
        return (React.createElement(motion.button, { type: "button", onClick: (e) => onChange(e, meal), className: classNames("card plan-item", {
                "validation-error": !this.isValid()
            }), layout: true, variants: mealItemAnim, initial: "hidden", animate: "show" },
            React.createElement("div", { className: "plan-item-image img-hover-zoom" },
                React.createElement(MealImage, { images: meal.images })),
            React.createElement("div", { className: "card-header" },
                React.createElement("h3", null, category),
                React.createElement("span", { className: "btn btn-outline-cta" }, "Change")),
            meal.variant_id ? this.renderMeal(meal, nutriants) : this.renderBlank(),
            React.createElement("input", { type: "hidden", value: meal.variant_id || "", name: `product[${meal.day_number}][${meal.display_order}]` })));
    }
    renderMeal(meal, nutriants) {
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: "card-body" },
                React.createElement("h4", { className: "card-title" }, meal.name)),
            React.createElement("div", { className: "card-footer" },
                React.createElement("table", null,
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", null, "Calories"),
                            React.createElement("th", null, "Protein"),
                            React.createElement("th", null, "Carbs"),
                            React.createElement("th", null, "Fat"))),
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                nutriants.Calories || 0,
                                " kcal"),
                            React.createElement("td", null,
                                nutriants.Protein || 0,
                                "g"),
                            React.createElement("td", null,
                                nutriants.Carbohydrates || 0,
                                "g"),
                            React.createElement("td", null,
                                nutriants.Fat || 0,
                                "g"))))));
    }
    renderBlank() {
        const { category } = this.props;
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: "card-body" },
                React.createElement("h4", { className: "card-title" },
                    React.createElement("i", { className: "far fa-plus-circle" }),
                    " Please add a ",
                    category)),
            React.createElement("div", { className: "card-footer" }));
    }
    componentDidUpdate(prevProps) {
        if (prevProps.meal.variant_id !== this.props.meal.variant_id) {
            this.setState({
                justChanged: true
            });
        }
    }
}
